import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { AboutPage } from './pages/AboutPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-ivory font-sans text-ink selection:bg-teal/20" data-id="element-1">
        <Navbar data-id="element-2" />
        <main data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/about" element={<AboutPage data-id="element-8" />} data-id="element-7" />
          </Routes>
        </main>
        <Footer data-id="element-9" />
      </div>
    </BrowserRouter>;
}